import { all, call, put, takeLatest } from 'redux-saga/effects'
import CommonActionTypes from './common-types'
import * as commonAction from './common-actions'
import { patchRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import * as allAssetsActions from 'redux/allAssets/allAssets-actions.js'

function* startChangeAccountLabel({ payload: data }) {
    try {
        yield patchRequest(`/user/assets/${data.assetId}`, { label: data.label })
        yield put(commonAction.successChangeAccountLabel())
        yield put(allAssetsActions.startFetchAllAssets())
    } catch (err) {
        yield put(commonAction.failureChangeAccountLabel({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}
export function* onStartChangeAccountLabel() {
    yield takeLatest(CommonActionTypes.START_CHANGE_ACCOUNT_LABEL, startChangeAccountLabel)
}

export function* commonSagas() {
    yield all([call(onStartChangeAccountLabel)])
}
